import actionTypes from '../constants/action-types';

const updatedAt = (state = null, action) => {
  if (action.type !== actionTypes.CONNECT_MAPPED_HTML) return state;
  return new Date().getTime();
};

export default updatedAt;
